import $api from "../http";
import { AxiosResponse } from "axios";

/**
 * `РГ-07` (ФЗ-152): машиноместа объекта.
 *
 * Обозначение приходит с сервера дословно — так, как внесено по договору;
 * форма его не досочиняет и не приводит к «удобному» виду.
 */
export interface IMachinePlace {
  id: number;
  plantId: number;
  number: string | null;
  description: string | null;
}

export default class MachinePlaceService {
  static list(plantId: number): Promise<AxiosResponse<IMachinePlace[]>> {
    return $api.get<IMachinePlace[]>("/machine-places", {
      params: { plantId },
    });
  }
}
